<template>
  <div class="topbar">
    <div
      id="c-mask-user-menu"
      @click="toggleUserMenu()"
      v-bind:class="{ 'is-active': !isUserMenuHidden }"
    ></div>

    <nav
      class="nav" 
      :style="{ 'margin-left': this.isCurrentUserClient ? '0' : '300px' }"
    >
      <div class="nav-left">
        <!--<a
           class="nav-item sidebar-button"
           id="toggle-menu-button"
           @click='toggleSidebar()'
           :class="{'selected': !isSidebarHidden}"
           v-if="!isCurrentUserClient"

        >
          ≡
        </a>-->

        <div class="nav-item">
          <div class="block-cont">
            <div class="level">
              <div v-if="isCurrentUserClient" class="level-item">
                <strong>
                  <router-link :to="{name: 'productions'}">
                    {{ $t("productions.title") }}
                  </router-link>
                </strong>
                <strong>
                  <router-link :to="{name: 'main-schedule'}">
                    {{ $t("schedule.title_main") }}
                  </router-link>
                </strong>
                <div class="production-links" v-if="isProductionContext">
                  <strong>
                    <router-link :to="{name: 'playlists'}">
                      {{ $t("playlists.title") }}
                    </router-link>
                  </strong>
                  <strong>
                    <router-link :to="{name: 'sequence-stats'}">
                      {{ $t("sequences.stats_title") }}
                    </router-link>
                  </strong>
                  <strong>
                    <router-link :to="{name: 'production-asset-types'}">
                      {{ $t("asset_types.production_title") }}
                    </router-link>
                  </strong>
                  <strong>
                    <router-link :to="{name: 'episode-stats'}">
                      {{ $t("episodes.stats_title") }}
                    </router-link>
                  </strong>
                </div>
              </div>
              <div v-else class="level-item">
                <strong>
                  <router-link :to="{name: 'productions'}">
                    {{ $t("productions.title") }}
                  </router-link>
                </strong>
                <strong>
                  <router-link :to="{name: 'people'}">
                    {{ $t("people.title") }}
                  </router-link>
                </strong>
                <!-- <strong>
                  <router-link :to="{name: 'timesheets'}">
                    {{ $t("timesheets.title") }}
                  </router-link>
                </strong> -->
                <strong>
                  <router-link :to="{name: 'main-schedule'}">
                    {{ $t("schedule.title_main") }}
                  </router-link>
                </strong>
                <strong>
                  <router-link :to="{name: 'team-schedule'}">
                    {{ $t("team_schedule.title_main") }}
                  </router-link>
                </strong>
                <strong>
                  <router-link v-if="isCurrentUserAdmin" :to="{name: 'timelog'}">
                    {{ $t("timelog.title") }}
                  </router-link>
                </strong>
                <strong>
                  <router-link v-if="isCurrentUserAdmin" :to="{name: 'holidays'}">
                    {{ $t("main.holidays") }}
                  </router-link>
                </strong>
              </div>
            </div>

            <div class="crumb-trail" v-if="isProductionContext">
              <span v-if="currentProduction">{{ currentProduction.name }}</span>
              <span
                class="crumb-pointer"
                v-if="currentProjectSection"
              >
              >
              </span>
              <span class="crumb">{{ currentProjectSection }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="nav-right">
        <div class="nav-item">
          <div class="level">
            <div class="level-item">
              <strong>
                <router-link :to="{name: 'todos'}">
                  {{ $t("tasks.my_tasks") }}
                </router-link>
              </strong>
            </div>
          </div>
        </div>
        <notification-bell />
        <div class="nav-item">
          <a
            class="changelog-button help-button"
            href="https://kitsu.cg-wire.com/"
            target="_blank"
          >
            <help-circle-icon />
          </a>
        </div>
        <div
          :class="{
            'nav-item': true,
            'user-nav': true,
            active: !isUserMenuHidden
          }"
          ref="user-name"
          @click="toggleUserMenu"
        >
          <people-avatar
            ref="avatar"
            class="avatar"
            :no-cache="true"
            :person="user"
            :is-link="false"
          />
          <people-name
            class="user-name"
            :person="user"
          />
        </div>
      </div>
    </nav>

    <nav
      class="user-menu"
      ref="user-menu"
      v-show="!isUserMenuHidden"
    >
      <ul>
        <li>
          <router-link to="/profile" @click.native="toggleUserMenu()">
            {{ $t("main.profile") }}
          </router-link>
        </li>
        <li @click="toggleDarkTheme">
          <span v-if="!isDarkTheme">
            {{ $t('main.dark_theme') }}
          </span>
          <span v-else>
            {{ $t('main.white_theme') }}
          </span>
        </li>
        <li>
          <a
            href="https://www.youtube.com/playlist?list=PLp_1gB5ZBHXqnQgZ4TCrAt7smxesaDo29"
            target="_blank"
          >
            {{ $t('main.tutorials') }}
          </a>
        </li>
        <li>
          <a
            @click="display.shortcutModal = true"
          >
            {{ $t('keyboard.shortcuts') }}
          </a>
        </li>
        <li @click="onLogoutClicked">
          {{ $t("main.logout") }}
        </li>
        <li class="version">
          Kitsu {{ kitsuVersion }}
        </li>
      </ul>
    </nav>

    <shortcut-modal
      :active="display.shortcutModal"
      @cancel="display.shortcutModal = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import {
  HelpCircleIcon,
  LogOutIcon
} from 'vue-feather-icons'

import GlobalSearchField from '@/components/tops/GlobalSearchField'
import NotificationBell from '@/components/widgets/NotificationBell'
import PeopleAvatar from '@/components/widgets/PeopleAvatar'
import PeopleName from '@/components/widgets/PeopleName'
import ShortcutModal from '@/components/modals/ShortcutModal'
import TopbarEpisodeList from '@/components/tops/TopbarEpisodeList'
import { version } from '@/../package.json'

export default {
  name: 'topbar',
  components: {
    GlobalSearchField,
    HelpCircleIcon,
    LogOutIcon,
    NotificationBell,
    PeopleName,
    PeopleAvatar,
    TopbarEpisodeList,
    ShortcutModal
  },

  data() {
    return {
      currentProductionId: this.$route.params.production_id,
      currentEpisodeId: this.$route.params.episode_id,
      currentProjectSection: this.isCurrentUserClient ? 'playlists' : 'shots',
      kitsuVersion: version,
      silent: false,
      display: {
        shortcutModal: false
      }
    }
  },

  mounted () {
    const userMenu = this.$refs['user-menu']
    const userName = this.$refs['user-name']
    if (userName) {
      const userNameWidth = userName.clientWidth

      if (userNameWidth > 100) {
        userMenu.style.width = `${userNameWidth}px`
        userName.style.width = `${userNameWidth}px`
      }
    }

    // this.setProductionFromRoute()
  },

  computed: {
    ...mapGetters([
      'assetsPath',
      'currentEpisode',
      'currentProduction',
      'episodes',
      'episodeOptionGroups',
      'isCurrentUserAdmin',
      'isCurrentUserArtist',
      'isCurrentUserClient',
      'isCurrentUserManager',
      'isCurrentUserSupervisor',
      'isCurrentUserVendor',
      'isDarkTheme',
      'isSidebarHidden',
      'isSupportChat',
      'isUserMenuHidden',
      'isTVShow',
      'isNewNotification',
      'lastProductionScreen',
      'lastProductionViewed',
      'mainConfig',
      'openProductions',
      'openProductionOptions',
      'productionMap',
      'productionEditTaskTypes',
      'user'
    ]),

    assetSections() {
      return ['assets', 'assetTypes', 'playlists']
    },

    editSections() {
      return ['edits']
    },

    shotSections() {
      return ['shots']
    },

    breakdownSections() {
      return ['breakdown']
    },

    // Asset pages require a all section and a main pack section.
    currentEpisodeOptionGroups() {
      if (this.assetSections.includes(this.currentProjectSection)) {
        return [
          {
            name: '',
            episodeList: [
              { label: this.$t('main.all_assets'), value: 'all' },
              { label: 'Main Pack', value: 'main' }
            ]
          }
        ].concat(this.episodeOptionGroups)
      } else if (['playlists'].includes(this.currentProjectSection)) {
        return [
          { label: this.$t('main.all_assets'), value: 'all' },
          { label: 'Main Pack', value: 'main' }
        ].concat(this.episodeOptions)
      } else {
        return this.episodeOptionGroups
      }
    },

    hasEpisodeId() {
      return this.$route.params.episode_id
    },

    isProductionContext() {
      return (
        this.$route.params.production_id !== undefined ||
        this.$route.path.indexOf('my-tasks') === 0
      )
    },

    lastProduction() {
      let production = this.productionMap.get(this.lastProductionViewed)
      if (!production) {
        production = this.currentProduction
      }
      return production
    },

    lastSectionPath() {
      const production = this.lastProduction
      const section = this.lastProductionScreen
      const route = {
        name: section,
        params: {
          production_id: production.id
        }
      }
      if (production.production_type === 'tvshow') {
        route.name = `episode-${section}`
        route.params.episode_id = production.first_episode_id
      }
      return route
    },

    sectionOptions () {
      let options = [
        { label: this.$t('assets.title'), value: 'assets' },
        { label: this.$t('shots.title'), value: 'shots' },
        { label: this.$t('sequences.title'), value: 'sequences' },
        { label: this.$t('episodes.title'), value: 'episodes' },
        {
          label: this.$t('asset_types.production_title'), value: 'assetTypes'
        },
        { label: this.$t('playlists.title'), value: 'playlists' }
      ]

      // Show these sections to studio members only.
      if (!this.isCurrentUserClient) {
        options = options.concat([
          { label: this.$t('news.title'), value: 'newsFeed' },
          { label: this.$t('breakdown.title'), value: 'breakdown' },
          { label: this.$t('schedule.title'), value: 'schedule' },
        ])
      } else {
        const playlistSection = options.pop()
        options = [playlistSection].concat(options)
      }

      if (this.isCurrentUserVendor) {
        options = [
          { label: this.$t('assets.title'), value: 'assets' },
          { label: this.$t('shots.title'), value: 'shots' },
          { label: this.$t('sequences.title'), value: 'sequences' },
          { label: this.$t('episodes.title'), value: 'episodes' },
          {
            label: this.$t('asset_types.production_title'), value: 'assetTypes'
          }
        ]
      }

      if (!this.isTVShow) { // Remove episode Section from the list.
        options.splice(3, 1)
      }
      return options
    }
  },

  methods: {
    ...mapActions([
      'clearEpisodes',
      'clearSelectedTasks',
      'loadEpisodes',
      'loadMilestones',
      'loadNotification',
      'incrementNotificationCounter',
      'logout',
      'setProduction',
      'setCurrentEpisode',
      'setSupportChat',
      'toggleDarkTheme',
      'toggleSidebar',
      'toggleUserMenu'
    ]),

    onLogoutClicked() {
      this.logout((err, success) => {
        this.$socket.disconnect()
        if (err) console.error(err)
        this.toggleUserMenu()
        if (success) this.$router.push('/login')
      })
    },

    getCurrentSectionFromRoute() {
      let name = ''
      const segments = this.$route.path.split('/')
      if (this.isTVShow) name = segments[5]
      if (this.isTVShow && name && name.length === 36) name = 'episodes'
      if (!name) {
        name = segments[3]
        if (name === 'episodes' && segments.length === 6) {
          name = segments[5]
        }
      }
      if (name === 'asset-types') name = 'assetTypes'
      if (name === 'news-feed') name = 'newsFeed'
      return name
    },

    updateContext(productionId) {
      if (!productionId) {
        this.clearContext()
      } else {
        this.setProductionFromRoute()
      }
    },

    clearContext() {
      this.silent = true
      this.currentProductionId = null
      this.currentProjectSection = null
      if (!this.isTVShow) {
        this.setCurrentEpisode(null)
        this.currentEpisodeId = null
      }
      this.setProduction(null)
      this.silent = false
    },

    setProductionFromRoute() {
      const routeProductionId = this.$route.params.production_id
      const routeEpisodeId = this.$route.params.episode_id

      if (this.isProductionChanged(routeProductionId)) {
        this.configureProduction(routeProductionId)
      } else if (this.isEpisodeChanged(routeEpisodeId)) {
        this.configureEpisode(routeEpisodeId)
      } else {
        this.updateCombosFromRoute()
      }
    },

    configureProduction(routeProductionId) {
      this.setProduction(routeProductionId)
      if (this.isTVShow) {
        this.loadEpisodes()
          .then(episodes => {
            this.updateCombosFromRoute()
          })
          .catch(console.error)
      } else {
        this.updateCombosFromRoute()
      }
    },

    configureEpisode(routeEpisodeId) {
      if (this.episodes.length < 2) {
        this.loadEpisodes()
          .then(episodes => {
            this.setEpisodeFromRoute()
            this.updateCombosFromRoute()
          })
          .catch(console.error)
      } else {
        this.setEpisodeFromRoute()
        this.updateCombosFromRoute()
      }
    },

    isProductionChanged(productionId) {
      return (
        !this.currentProduction ||
        this.currentProductionId !== productionId ||
        this.currentProduction.id !== productionId
      )
    },

    isEpisodeChanged(episodeId) {
      return (
        this.isTVShow &&
        (!this.currentEpisode ||
          this.currentEpisodeId !== episodeId ||
          this.currentEpisode.id !== episodeId)
      )
    },

    setEpisodeFromRoute() {
      const routeEpisodeId = this.$route.params.episode_id
      if (this.isEpisodeChanged(routeEpisodeId)) {
        if (routeEpisodeId && this.isTVShow) {
          this.setCurrentEpisode(routeEpisodeId)
        }
      } else if (!routeEpisodeId) {
        this.silent = true
        this.currentEpisodeId = null
        this.silent = false
      }
    },

    updateCombosFromRoute() {
      const episodeId = this.$route.params.episode_id
      const section = this.getCurrentSectionFromRoute()
      this.silent = true
      this.currentProjectSection = section
      this.silent = false // wtf is this doing?
    }
  },

  watch: {
    // $route() {
    //   const productionId = this.$route.params.production_id
    //   this.updateContext(productionId)
    // },

    // currentProductionId () {
    //   this.resetEpisodeForTVShow()
    //   if (this.currentProduction.isTVShow) this.loadEpisodes()
    //   this.updateRoute()
    // },

    // currentProjectSection () {
    //   this.updateRoute()
    //   if (this.silent) return
    //   this.resetEpisodeForTVShow()
    // },

    // currentEpisodeId () {
    //   if (this.silent) return
    //   this.updateRoute()
    // },

    // currentEpisode () {
    //   if (!this.currentEpisode) {
    //     this.currentEpisodeId = null
    //   } else if (this.currentEpisodeId !== this.currentEpisode.id) {
    //     this.currentEpisodeId = this.currentEpisode.id
    //   }
    // }
  },

  socket: {
    events: {
      'notification:new' (eventData) {
        if (this.user.id === eventData.person_id) {
          const notificationId = eventData.notification_id
          this.loadNotification(notificationId)
        }
      },

      'person:update'(eventData) {
        if (this.user.id === eventData.person_id) {
          this.$refs.avatar.reloadAvatar()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.nav {
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
  left: 0;
  max-height: 60px;
  min-height: 60px;
  position: fixed;
  right: 0;
  margin-left: 200px;
}

#toggle-menu-button {
  font-size: 2em;
}

.avatar {
  margin-right: 10px;
  min-width: 40px;
}

.user-nav {
  cursor: pointer;
  min-width: 150px;
}

.user-menu {
  position: fixed;
  top: 60px;
  width: 200px;
  min-width: 150px;
  right: 0;
  background-color: white;
  padding: 1em 1em 1em 1em;
  z-index: 203;
  box-shadow: 2px 3px 3px rgba(0,0,0,0.2);
  transition-property: all;
  transition-duration: .5s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  border-left: 1px solid $white-grey;
  border-bottom: 1px solid $white-grey;
}

.user-menu ul {
  margin-left: 0;
}

.user-menu li {
  cursor: pointer;
  padding: 0.2em;
  font-size: 1.1em;
  list-style-type: none;
}

.user-menu li a {
  color: $white;
}

#c-mask-user-menu {
  position: fixed;
  z-index: 202;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  overflow: hidden;
  background-color: #000;
  opacity: 0;
}

#c-mask-user-menu.is-active {
  width: 100%;
  height: 100%;
}

.nav-right {
  padding-right: 0;
  flex-grow: 0;
}

.context-selector-label {
  margin-right: 1em;
}

.context-selector {
  margin-right: 1em;
  margin-bottom: 1.5em;
}

.icon-link {
  margin: 0 0.5em;
}

strong {
  margin-right: 1em;
  margin-left: 1em;
}

.version {
  color: $grey;
}

.user-name {
  color: $white;
  min-width: 130px;
  text-align: left;
}

.nav-left {
  padding-top: 8px;
}

@media screen and (max-width: 768px) {
  .home-button {
    display: none;
  }

  .nav-right {
    display: flex;
    flex: 0;
  }

  .nav-item {
    justify-content: right;
  }

  .user-name {
    display: none;
  }

  .avatar {
    margin-right: 0;
  }

  .user-menu {
    right: -160;
  }

  .icon-link,
  .context-selector-label {
    display: none;
  }

  .field.context-selector {
    padding: 0;
    margin-top: 2em;
  }
}

.block-cont {
  display: block;
}

.crumb-trail {
  width: fit-content;
  margin-left: 1em;
  margin-top: -0.7em;
  margin-bottom: 6px;
}

.crumb-pointer{
  padding-left: 0.8em;
  padding-right: 0.8em;
}

.crumb {
  text-transform: capitalize;
}

.production-links {
  margin-left: 3em;
}

:deep(.select-input) {
  position: absolute;
  top: 58px;
}

// .dark {
  a,
  .user-menu a {
    color: $white-grey;
  }

  #toggle-menu-button:hover {
    color: $white-grey;
  }

  .topbar .nav,
  .user-menu {
    background-color: $black;
    color: $white-grey;
    border-left: 1px solid #2f3136;
    border-bottom: 1px solid #2f3136;
  }
// }
</style>
